import styled from 'styled-components';

import ThemeHelper from '@themes/theme-helper';

export const Root = styled.div(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    display: flex;
    justify-content: center;
    align-items: center;

    border: 1px solid ${colours.grey[400]};
    background-color: ${colours.grey[200]};
    min-width: 52px;
    height: 45px;

    > div {
      margin: 0;
    }
`;
});

export default Root;



// WEBPACK FOOTER //
// ./components/grid/grid-header/styled.js